var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 11.25L12.625 18.125L9.5 15",
    stroke: "#009A49",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5001 1.85938C16.2257 1.85938 17.9345 2.19927 19.5288 2.85965C21.1231 3.52002 22.5717 4.48796 23.7919 5.70818C25.0121 6.9284 25.98 8.37701 26.6404 9.9713C27.3008 11.5656 27.6407 13.2744 27.6407 15C27.6407 16.7257 27.3008 18.4344 26.6404 20.0287C25.98 21.623 25.0121 23.0716 23.7919 24.2918C22.5717 25.512 21.1231 26.48 19.5288 27.1404C17.9345 27.8007 16.2257 28.1406 14.5001 28.1406C12.7744 28.1406 11.0657 27.8007 9.47136 27.1404C7.87706 26.48 6.42845 25.512 5.20823 24.2918C3.98801 23.0716 3.02008 21.623 2.3597 20.0287C1.69933 18.4344 1.35944 16.7256 1.35944 15C1.35944 13.2743 1.69933 11.5656 2.35971 9.97129C3.02009 8.377 3.98802 6.92839 5.20824 5.70817C6.42846 4.48795 7.87707 3.52002 9.47137 2.85964C11.0657 2.19927 12.7744 1.85937 14.5001 1.85938L14.5001 1.85938Z",
    stroke: "#F2F4F7",
    strokeWidth: 2.71875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5001 1.85938C16.2257 1.85938 17.9345 2.19927 19.5288 2.85965C21.1231 3.52002 22.5717 4.48796 23.7919 5.70818C25.0121 6.9284 25.98 8.37701 26.6404 9.9713C27.3008 11.5656 27.6407 13.2744 27.6407 15C27.6407 16.7257 27.3008 18.4344 26.6404 20.0287C25.98 21.623 25.0121 23.0716 23.7919 24.2918C22.5717 25.512 21.1231 26.48 19.5288 27.1404C17.9345 27.8007 16.2257 28.1406 14.5001 28.1406C12.7744 28.1406 11.0657 27.8007 9.47136 27.1404C7.87706 26.48 6.42845 25.512 5.20823 24.2918C3.98801 23.0716 3.02008 21.623 2.3597 20.0287C1.69933 18.4344 1.35944 16.7256 1.35944 15C1.35944 13.2743 1.69933 11.5656 2.35971 9.97129C3.02009 8.377 3.98802 6.92839 5.20824 5.70817C6.42846 4.48795 7.87707 3.52002 9.47137 2.85964C11.0657 2.19927 12.7744 1.85937 14.5001 1.85938L14.5001 1.85938Z",
    stroke: "#009A49",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle);
export default __webpack_public_path__ + "static/media/circle.423f846f5d771f587264df0b8a1cdfd9.svg";
export { ForwardRef as ReactComponent };